import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Activity, Heart, Calendar, Utensils, ShoppingCart, RefreshCw, Clock, List, BookMarked, Sparkles } from 'lucide-react';
export function IncludesGrid() {
  const items = [{
    text: 'Entender la inflamación y sus señales reales en el cuerpo femenino',
    icon: Activity
  }, {
    text: 'Las causas ocultas: alimentación, intestino, estrés, sueño y hormonas',
    icon: Heart
  }, {
    text: 'Plan antiinflamatorio integral (no solo comida)',
    icon: Sparkles
  }, {
    text: 'Plan de acción de 21 días paso a paso',
    icon: Calendar
  }, {
    text: 'Menús semanales completos (3 semanas)',
    icon: Utensils
  }, {
    text: 'Listas de compra inteligentes y organizadas',
    icon: ShoppingCart
  }, {
    text: 'Vida antiinflamatoria sostenible (después de los 21 días)',
    icon: RefreshCw
  }, {
    text: 'Recetario express con 15 recetas antiinflamatorias rápidas',
    icon: Clock
  }, {
    text: 'Tabla completa de alimentos antiinflamatorios y proinflamatorios',
    icon: List
  }, {
    text: 'Diario de síntomas y progreso (plantilla de 21 días)',
    icon: BookMarked
  }, {
    text: 'Glosario, recursos y anexos bonus',
    icon: BookOpen
  }];
  const breakdown = [{
    label: 'Ebook completo: explicación de la inflamación femenina (132 págs)',
    price: '$30 USD'
  }, {
    label: 'Plan estructurado de acción de 21 días',
    price: '$40 USD'
  }, {
    label: 'Recetario express con 15 recetas antiinflamatorias',
    price: '$25 USD'
  }, {
    label: 'Diario de síntomas y progreso (plantilla 21 días)',
    price: '$15 USD'
  }, {
    label: 'Glosario completo + anexos de referencia',
    price: '$20 USD'
  }, {
    label: 'Tabla completa de alimentos antiinflamatorios y proinflamatorios',
    price: '$17 USD'
  }];
  return <section className="w-full px-4 py-20 bg-ivory" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-6" data-id="element-151">
            Todo lo que incluye tu guía
          </h2>
          <p className="text-lg text-ink/70 max-w-2xl mx-auto" data-id="element-152">
            Un sistema completo diseñado para llevarte de la confusión a la
            claridad.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-153">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-cream p-6 rounded-2xl border border-taupe/10 hover:border-clay/30 transition-colors group" data-id="element-154">
                <div className="flex items-start gap-4" data-id="element-155">
                  <div className="flex flex-col items-center gap-3" data-id="element-156">
                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-clay/10 text-clay font-serif font-bold text-sm" data-id="element-157">
                      {(index + 1).toString().padStart(2, '0')}
                    </span>
                    <Icon className="w-5 h-5 text-taupe group-hover:text-clay transition-colors" data-id="element-158" />
                  </div>
                  <p className="text-ink/90 font-medium leading-snug pt-1" data-id="element-159">
                    {item.text}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Full-width value-stack breakdown */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mt-10 bg-sage/5 border-2 border-sage/30 rounded-3xl px-6 md:px-12 py-10 md:py-14 shadow-[0_30px_80px_-40px_rgba(92,107,79,0.45)]" data-id="element-160">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-sage text-ivory text-[10px] md:text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full" data-id="element-161">
            Valor real de tu guía
          </span>

          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-162">
            <h3 className="text-3xl md:text-4xl font-serif text-ink mb-3" data-id="element-163">
              Todo esto, en una sola guía
            </h3>
            <p className="text-sm md:text-base text-muted" data-id="element-164">
              Si compraras cada recurso por separado, esto sería tu inversión
              real:
            </p>
          </div>

          {/* Breakdown list */}
          <ul className="max-w-3xl mx-auto divide-y divide-sage/15 mb-8" data-id="element-165">
            {breakdown.map((item, i) => <li key={i} className="flex items-baseline justify-between gap-4 py-4" data-id="element-166">
                <span className="text-sm md:text-base text-ink/85 leading-snug" data-id="element-167">
                  {item.label}
                </span>
                <span className="hidden sm:block flex-1 mx-3 border-b border-dotted border-taupe/40 translate-y-[-3px]" aria-hidden="true" data-id="element-168" />
                <span className="text-sm md:text-base font-semibold text-ink whitespace-nowrap tabular-nums" data-id="element-169">
                  {item.price}
                </span>
              </li>)}
          </ul>

          {/* Separator */}
          <div className="max-w-3xl mx-auto border-t-2 border-sage/30 pt-6 text-center" data-id="element-170">
            <p className="text-sm md:text-base text-muted mb-4" data-id="element-171">
              Valor total por separado:{' '}
              <span className="line-through decoration-1" data-id="element-172">$147 USD</span>
            </p>
            <p className="font-serif text-3xl md:text-5xl font-bold text-clay leading-tight mb-2" data-id="element-173">
              Hoy todo incluido por $9.99 USD
            </p>
            <p className="text-sm text-muted/90" data-id="element-174">
              Ahorras <span className="font-semibold text-sage" data-id="element-175">$137</span> al
              adquirirlo como guía integral
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}